// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2THrh","name":"styles_name__3OCOB","phone":"styles_phone__1DGIa"};